import { GetPlansOptions, getPlans } from '../api/subscription-service/getPlans'
import { Plan } from '@dtx-company/true-common/src/types/Plan'
import { UseAPIConfig, UseAPIOptions, UseAPIResponse, useAPI } from './useAPI'

export type UsePlansOptions = UseAPIOptions<GetPlansOptions>
export type UsePlansConfig = UseAPIConfig<Plan[], Error>
export type UsePlansResponse = UseAPIResponse<Plan[], Error>

/**
 * Wraps useSWR to retrieve subscription plans from the api.
 */
export function usePlansSWR(options: UsePlansOptions, config?: UsePlansConfig): UsePlansResponse {
  return useAPI<GetPlansOptions, Plan[], Error>('usePlans', getPlans, options, config)
}
